<template>
<b-container fluid text-center>
  <b-col class="d-none d-md-block">
  <div class="d-flex p-1 justify-content-between border-bottom">
    <h2 v-if="$router.currentRoute.name === 'display-group'">Group Management</h2>
    <h2 v-else>{{ display.name }}</h2>
    <b-button-toolbar>
      <b-button-group class="delete-button">
        <b-button v-for="button in buttons" v-bind:key="button.route" :disabled="$router.currentRoute.name === button.route" :variant="$router.currentRoute.name === button.route ? 'primary' : 'outline-primary'" :to="{ name: button.route, params: { displayId: display.displayId } }">{{$t(button.label)}}</b-button>
      </b-button-group>
      <div class="danger-area">
        <b-button variant="outline-danger" @click="deleteDisplay()">{{$t('actions.delete')}}</b-button>
      </div>
    </b-button-toolbar>
  </div>
  </b-col>
<!-- For mobile viewing -->
  <b-col class="d-md-none">
  <div class="d-flex p-1 justify-content-between border-bottom">
  <h3 v-if="$router.currentRoute.name !== 'display-group'">{{ display.name }}</h3>
    <b-dropdown id="dropdown-1" :text="$t('actions.actions')" class="m-2" variant="outline-dark" size="lg">
      <b-dropdown-item v-for="button in buttons" v-bind:key="button.route" :to="{ name: button.route, params: { displayId: display.displayId } }"><h5>{{$t(button.label)}}</h5></b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item variant="danger" @click="deleteDisplay()"><h5>{{$t('actions.delete')}}</h5></b-dropdown-item>
    </b-dropdown>
  </div>
</b-col>

    <b-col cols="12" class="h-100 display-main">
      <transition name="fade">
        <router-view v-if="display.displayId" :activeTeam="activeTeam" :display="{...display}" @refreshDisplays="$emit('refreshDisplays')"></router-view>
      </transition>
    </b-col>

</b-container>
</template>

<style scoped lang="scss">
  .fade-enter-active {
    transition: opacity .5s
  }
  .fade-enter {
    opacity: 0
  }

  .display-nav {
    border-bottom: #e9e9e9 solid 1px;
    padding: 0 20px 0 20px;
    position: fixed;
    z-index: 50;
    background-color: white;
  }

  .delete-button {
    margin: 5px;
  }

  // Delete is set apart from the tabs.
  .danger-area {
    margin: 5px 5px 5px 16px;
    padding-left: 16px;
    border-left: #e9e9e9 solid 1px;
  }


@import "node_modules/bootstrap/scss/_functions.scss";
@import "node_modules/bootstrap/scss/_variables.scss";
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

  @include media-breakpoint-up(xs) {
    .dropdown-toggle {
      display: none;

      &.ellipsis {
        display:block;
      }
    }
  }

  @include media-breakpoint-up(md) {
    .dropdown-toggle {
      display: block;

      &.ellipsis {
        display: none;
      }
    }

    .display-nav {
      position: absolute;
    }
  }

</style>

<script>
import teamContext from '@/mixins/teamContext'
import { confirmDanger } from '@/lib/confirm'

export default {
  name: 'Display',
  mixins: [teamContext],
  props: {
    display: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      show: false,
      dropdownOpen: false,
      buttons: [{
          label: 'actions.view',
          route: 'display-view'
        },
        {
          label: 'actions.edit',
          route: 'display-edit'
        }, {
          label: 'actions.dashboard',
          route: 'display-dashboard'
        }, {
          label: 'actions.group',
          route: 'display-group'
        }, {
          label: 'actions.coupons',
          route: 'display-coupons'
        }, {
          label: 'actions.pricing',
          route: 'display-pricing'
        }
      ],
    }
  },
  beforeDestroy () {
    this.$emit('refresh')
  },
  methods: {
    async deleteDisplay () {
      if (!await confirmDanger(this, 'deleteDisplay', { name: this.display.name }, 'actions.delete')) return
      this.$axios.delete('v1/displays/' + this.display.displayId).then(
      () => {
        this.$notifications.add({
          title: 'Success',
          type: 'success',
          body: this.$t('notifications.displayDelete'),
          timeout: true
        })
        this.$emit('delete')
      },
      (error) => {
        this.$notifications.add({
          title: 'Error',
          type: 'danger',
          body: error.response?.data?.message || this.$t('notifications.displayDeleteError'),
          timeout: true
        })
      })
    }
  }
}
</script>
